import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { FireflyFroalaLicenseProvider } from '@capital-access/firefly/components';
import { FroalaLicenseProvider } from './froala-license.provider';

@NgModule({
  imports: [CommonModule]
})
export class FroalaModule {
  static forRoot(): ModuleWithProviders<FroalaModule> {
    return {
      ngModule: FroalaModule,
      providers: [
        {
          provide: FireflyFroalaLicenseProvider,
          useClass: FroalaLicenseProvider
        },
        provideAppInitializer(() => {
          const initializerFn = (
            (licenseService: FireflyFroalaLicenseProvider) => () =>
              licenseService.validateLicense()
          )(inject(FireflyFroalaLicenseProvider));
          initializerFn();
        })
      ]
    };
  }
}
